import { Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';

interface FieldProps extends BoxProps {
  children: ReactNode;
}

export const Field = ({ children, ...rest }: FieldProps) => {
  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
      })}
      {...rest}
    >
      {children}
    </Box>
  );
};
